module.exports = __webpack_public_path__ + "static/backed_by_science_mobile-7f62567e643167f83465971a18cab87a.jpg";